import { render, staticRenderFns } from "./caseDialogue.vue?vue&type=template&id=1b2e6e60&lang=pug"
import script from "./caseDialogue.vue?vue&type=script&lang=js"
export * from "./caseDialogue.vue?vue&type=script&lang=js"
import style0 from "./caseDialogue.vue?vue&type=style&index=0&id=1b2e6e60&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports